export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_da.40b3bf8df26ea945.json"